import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDeliveryMini = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.4887 16.3287H9.771"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5789 16.3287H22.005V11.9988L18.4335 8.30861H15.5112V8.31388V16.2894"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.0052 11.9988H15.5112"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.37601 14.8228C7.13713 14.0617 8.37107 14.0617 9.13219 14.8228C9.89326 15.584 9.89326 16.818 9.13219 17.5791C8.37107 18.3403 7.13713 18.3403 6.37601 17.5791C5.6149 16.818 5.6149 15.584 6.37601 14.8228Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.2383 14.8228C17.9994 14.0617 19.2333 14.0617 19.9945 14.8228C20.7556 15.584 20.7556 16.818 19.9945 17.5791C19.2333 18.3403 17.9994 18.3403 17.2383 17.5791C16.4772 16.818 16.4772 15.584 17.2383 14.8228Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.96582 5.00001V16.3219H5.72434"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5292 8.31387V5H3.96582"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.28548 5H3.96582"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.28559 7.49086H2.87207"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.82865 9.98172H2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgDeliveryMini;
